<template>
  <div class="login">
    <div class="sidebar">
      <div class="flex">
        <img class="h-20 mr-4" src="~@/assets/img/logo.svg" />
        <div class="brand">
          <div class="title">PandaVue</div>
          <div class="subtitle">WWF-Australia</div>
        </div>
      </div>
      <form @submit.prevent="login">
        <Alert :message="message"></Alert>
        <div class="field">
          <label>Email</label>
          <input required v-model="email" type="text" name="email" data-cy="email" />
        </div>
        <div class="field">
          <label>Password</label>
          <input required v-model="password" type="password" name="password" data-cy="password" />
        </div>
        <button name="" type="submit" :class="[loading === 1 ? 'load' : loading === 2 ? 'ok' : null]">Login</button>
        <div class="link" v-on:click="navigateTo('/forgot-password')">Forgot password →</div>
      </form>
      <div class="footer"></div>
    </div>
    <div class="image bg-local" :style="{ 'background-image': 'url(\'' + image + '\')' }"></div>
  </div>
</template>

<script>
import Alert from '../components/Alert.vue';

export default {
  name: 'Login',
  components: {
    Alert,
  },

  data() {
    return {
      email: '',
      password: '',
      image: require(`@/assets/img/background.jpg`),
      loading: 0,
      message: null,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters['auth/isLoggedIn'];
    },
  },
  watch: {
    // The value can be delayed if we need to refresh
    isLoggedIn(newVal) {
      if (newVal) {
        this.$router.push('/home').catch(() => {});
      }
    },
  },

  beforeMount() {
    this.$store.dispatch('auth/logout');
  },
  methods: {
    login: function () {
      this.loading = 1;
      this.message = null;
      const email = this.email;
      const password = this.password;

      this.$store
        .dispatch('auth/login', { email, password })
        .then(() => {
          this.loading = 2;
          setTimeout(() => (this.loading = 0), 500);
        })
        .catch((err) => {
          this.loading = 0;
          this.message = {
            content: err.message ? err.message : err.data.message,
            type: 'error',
          };
        });
    },
    navigateTo: function (url) {
      if (this.$route.path !== url) {
        this.$router.push({ path: url });
      }
    },
  },
};
</script>

<style scoped>
.login {
  @apply flex h-screen w-full;
}

.sidebar {
  @apply flex flex-col justify-between items-start w-96 p-6 bg-gray-50;
}

button {
  @apply mt-4;
}

.link {
  @apply text-gray-600 cursor-pointer;
}

.image {
  @apply hidden md:flex-1 md:flex items-center justify-center bg-white bg-cover;
}

.brand {
  @apply flex flex-col justify-center;
}

.brand .title {
  @apply text-xl font-bold;
}

.brand .subtitle {
  @apply text-xs;
}
</style>
